import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { NgbModal, NgbModalConfig } from "@ng-bootstrap/ng-bootstrap";
import { SolicitudCambiarEstadoI } from "src/app/infraestructure/models/solicitudCambiarEstado.interface";
import { ReferentApiService } from "src/app/infraestructure/services/referent/referent-api.service";
import { Observable, Subject, takeUntil } from "rxjs";
import { SolicitudesPendientesAprobacionDTO } from "src/app/infraestructure/interfaces/referente/SolicitudPendienteAprobacionDTO";
import { AppState, UserLogin } from "ngx-sds-login";
import { Store } from "@ngrx/store";

@Component({
  selector: "app-aprobacion-servicio-directivo",
  templateUrl: "./aprobacion-servicio-directivo.component.html",
  styleUrls: ["./aprobacion-servicio-directivo.component.scss"],
})
export class AprobacionServicioDirectivoComponent implements OnInit {

  private $topSubcription = new Subject<void>();
  cambiarEstadoSolicitud = {} as SolicitudCambiarEstadoI;
  solicitudSeleccionada = {} as SolicitudesPendientesAprobacionDTO;
  user$: Observable<UserLogin>;

  actionBtn: boolean = false;
  reloadTable: boolean = false;
  codeSolicitud: number = 0;
  rolId: number = 0;
  userId: number = 0;

  constructor(
    public router: Router,
    private referentApiSrv: ReferentApiService,
    private store: Store<AppState>,
    config: NgbModalConfig,
    private modalService: NgbModal
  ) {
    this.user$ = this.store.select(state => state.user);
    this.user$.subscribe(user => {
      this.rolId = user.rolId;
      this.userId = user.id;
    });

    config.backdrop = 'static';
    config.keyboard = false;
    config.size = 'xl';
  }

  ngOnInit(): void {
  }

  onAprobar() {
    this.cambiarEstadoSolicitud.accion = 'ENVIAR_SIGUIENTE_ESTADO';
    this.cambiarEstadoSolicitud.rolId = this.rolId;
    this.cambiarEstadoSolicitud.usuarioId = this.userId;
    this.cambiarEstadoSolicitud.solicitudId = this.codeSolicitud;
    this.cambiarEstadoSolicitud.datos = {};

    this.referentApiSrv.putSolicitudCambiarestado(this.cambiarEstadoSolicitud)
      .pipe(takeUntil(this.$topSubcription))
      .subscribe(res => {
        if (res.code === 200) {
          this.actionSucces('Solicitud de servicio aprobada', `La solicitud de servicio ha sido aprobada exitosamente con el #${res.data.solicitudId}`, 'reload');
        } else {
          const messages = res.errors.map((error: any) => `<li>${error.message}</li>`).join('\n');
          
          Swal.fire({
            title: 'Errores',
            icon: 'error',
            html: '<ul style="text-align: left; font-size: 0.8rem;">' + messages + '</ul>',
            showConfirmButton: true,
            confirmButtonColor: "#004884",
            confirmButtonText: "ACEPTAR",
          });
        }
      });
  }

  onRechazar() {
    Swal.fire({
      position: "center",
      icon: "warning",
      title: "<h5 style='color:#f8bb86'>" + '¿Esta seguro de rechazar la solicitud de servicio?' + "</h5>",
      text: `Motivo de rechazo*`,
      input: 'textarea',
      inputAttributes: {
        autocapitalize: 'off',
        maxlength: '800',
        style: 'margin: 10px;'
      },
      showConfirmButton: true,
      showCancelButton: true,
      showLoaderOnConfirm: true,
      preConfirm: (motivo) => {
        if (motivo.length < 1) return Swal.showValidationMessage('Campo obligatorio*.');
      },
      confirmButtonColor: "#2BA3BF",
      confirmButtonText: "ACEPTAR",
      cancelButtonText: "CANCELAR",
    }).then((result) => {
      if (result.isConfirmed) {
        this.cambiarEstadoSolicitud.accion = 'RECHAZAR';
        this.cambiarEstadoSolicitud.rolId = this.rolId;
        this.cambiarEstadoSolicitud.usuarioId = this.userId;
        this.cambiarEstadoSolicitud.solicitudId = this.codeSolicitud;
        this.cambiarEstadoSolicitud.datos = { TxtObservacion: result.value };

        this.referentApiSrv.putSolicitudCambiarestado(this.cambiarEstadoSolicitud)
          .pipe(takeUntil(this.$topSubcription))
          .subscribe(res => {
            if (res.code === 200) {
              this.actionSucces('Solicitud de rechazo exitosa', `La petición de rechazo de la solicitud de servicio #${res.data.solicitudId} ha sido procesada excitosamente`, 'reload')
            } else {
              const messages = res.errors.map((error: any) => `<li>${error.message}</li>`).join('\n');
          
              Swal.fire({
                title: 'Errores',
                icon: 'error',
                html: '<ul style="text-align: left; font-size: 0.8rem;">' + messages + '</ul>',
                showConfirmButton: true,
                confirmButtonColor: "#004884",
                confirmButtonText: "ACEPTAR",
              });
            }
          });
      };
    });
  }

  actionSucces(title: string, message: string, action?: string) {
    Swal.fire({
      position: "center",
      icon: "success",
      title: `${title}`,
      text: `${message}`,
      showConfirmButton: true,
      confirmButtonColor: "#004884",
      confirmButtonText: "ACEPTAR",
    });

    if (action === 'reload') {
      this.reloadTable = true;
    }
  }

  onValidate(validate: any) {
    if (validate === 'close') return this.modalService.dismissAll(validate);

    this.modalService.open(validate);
  }

  onCancel(cancel: any) {
    if (cancel === 'close') return this.modalService.dismissAll(cancel);

    this.modalService.open(cancel);
  }
}
